import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import type CaffeinateCampaignSubscriptionModel from './caffeinate-campaign-subscription.ts';
import type NotificationHistoryModel from './notification-history.ts';
import { Type } from '@warp-drive/core-types/symbols';

export interface TemplateSubstitutions {
  '-recipient_name-'?: string;
  '-to_email-'?: string;
  '-company_name-'?: string;
  '-employee_id-'?: string;
  [key: string]: string | undefined;
}

export default class CaffeinateMailingModel extends Model {
  @attr declare sendAt: string;
  @attr declare sentAt: string;
  @attr declare skippedAt: string;
  @attr declare mailerClass: string;
  @attr declare mailerAction: string;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;
  @attr declare templateSubstitutions: TemplateSubstitutions | null;

  @belongsTo('caffeinate-campaign-subscription', { async: false, inverse: 'caffeinateMailings' })
  declare caffeinateCampaignSubscription: CaffeinateCampaignSubscriptionModel;

  @belongsTo('notification-history', { async: false, inverse: null })
  declare notificationHistory: NotificationHistoryModel | null;

  // Convenience getters for common template values
  get recipientName(): string | undefined {
    return this.templateSubstitutions?.['-recipient_name-'];
  }

  get recipientEmail(): string | undefined {
    return this.templateSubstitutions?.['-to_email-'];
  }

  get companyName(): string | undefined {
    return this.templateSubstitutions?.['-company_name-'];
  }

  get employeeId(): string | undefined {
    return this.templateSubstitutions?.['-employee_id-'];
  }

  [Type] = 'caffeinate-mailing' as const;
}
